import MemberModel from "../member.model";
import ParseMedicalCardApi from "../../utils/api/ParseMedicalCardApi";

export default class HolderModel {
    constructor(data = {}) {
        this.id = data.id;
        this.member = data.member ? data.member.map( member => new MemberModel(member)) : [];
    }
}
